<script setup lang="ts">
const { contest_year } = useRoute().params;
import type { ContestDetail } from "@/types";
interface Props {
  yearArray: { id: number; name: string }[];
  list: ContestDetail[];
}

defineProps<Props>();
const router = useRouter();
function onSelectItem(e: number) {
  router.push(`/contents.php/contest${e}`);
}
</script>

<template>
  <div>
    <p class="text-xl font-bold mb-4">年度別に探す</p>
    <DropdownMenu
      :list="yearArray"
      @onSelectId="onSelectItem"
      class="border rounded mb-8"
    >
      <template v-slot:title>
        <p class="p-2 mr-2">
          {{ contest_year ? `${contest_year}年度` : "年度を選択" }}
        </p>
      </template>
    </DropdownMenu>
  </div>
</template>
